
import PageHeader from '@/components/PageHeader.vue';
import PageFooter from '@/components/PageFooter.vue';
import VenueIntroduce from '@/components/venue/VenueIntroduce.vue';
import VenueIntroduceTwo from '@/components/venue/VenueIntroduce2.vue';
import VenueSwiper from '@/components/swiper/VenueSwiper.vue';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {
    PageHeader,
    PageFooter,
    VenueSwiper,
    VenueIntroduce,
    VenueIntroduceTwo,
  }
})
export default class extends Vue {
   activeIndex = '1';

  swiperPartTwo: any = [
    {
      title: 'Gulangyu Island',
      text: 'Gulangyu Island enjoys the reputations of "Garden on the Sea", "World Architecture Expo" and "The Island of Music". From wonderful beaches, delicious snacks, and diverse colonial architectures and museums, Gulangyu Island gives a perfect example of what wonderland should be. In 2017, Gulangyu Island was declared a UNESCO World Heritage Site, which is also great evidence of how wonderful this island is.',
      path: 'https://www.getec.vip/data/g22/22-annual-website-2-gulangyu.jpg',
    },
    {
      title: 'Xiamen University',
      text: 'Xiamen University was founded in 1921 by Chen Jiageng, a famous patriotic overseas Chinese leader. It was built beside the mountain and near the sea, and contains many unique buildings combining Chinese and western architectural cultures, making it one of the most beautiful universities in China. One must-do in Xiamen is to see the interesting doodles painted by students on the walls of Furong Tunnel inside the campus. You can also have a romantic sight with your partner along the beautiful Furong Lake or in the Valley of Love.',
      path: 'https://www.getec.vip/data/g22/22-annual-website-2-xiada.jpg',
    },
    {
      title: 'Zhongshan Road',
      text: 'Zhongshan Road Pedestrian Street is a landmark in Xiamen. You can appreciate its unique arcade buildings and historical relics to feel long history and rich culture, purchase souvenirs in the markets hidden in the alleys, or drink a bowel of peanut soup in Huang Zehe, an old famous restaurant. In addition, the twenty-fourth floor of Haibin Mansion is the best viewing post to overlook the whole Gulangyu Island.',
      path: 'https://www.getec.vip/data/g22/22-annual-website-2-zhongshanroad.jpg',
    },
    {
      title: 'Nanputuo Temple',
      text: "Nanputuo Temple, is the most famous and beautiful temple in Xiamen. It is named after Putuo Mountain, a Buddhist mountain, which it is based at the foot of. The temple grounds have a peaceful atmosphere as they are surrounded by ponds and lotus flowers. As part of the temple, you'll find the Hall of Heavenly Kings, the Precious Hall of Great Hero, the Hall of Great Mercy and the Buddhist Scripture Garret to explore.",
      path: 'https://www.getec.vip/data/g22/22-annual-website-2-putuosi.jpg',
    },
    {
      title: 'Huandao Road',
      text: 'Xiamen Huandao Road refers to the road sections that set along the coastal of Xiamen. This road measures about 43 kilometers in total, and its most popular part starts from Xiamen University to the Old Convention and Exhibition Center, which is called the "Golden Coastline". Huandao Road is the best place for cycling in Xiamen, and it shows the best sea view and some of the best beaches to the visitors. Hulishan Fortress, a historical landmark, is also there.',
      path: 'https://www.getec.vip/data/g22/22-annual-website-2-huandaoroad.jpg',
    },
    {
      title: 'Xinglin Bridge',
      text: 'Xinglin Bridge is located in Xinglin Jimei District, Xiamen. It is a cross-sea passage connecting Jimei District and Huli District, located on the northern sea area of Xiamen. It is one of the four-shot structures of the main highway channel of Xiamen, and is also an important exit in the north of Xiamen. From time to time, you can see the train passing by, there is a wind dock nearby, it is very good to watch the sunset.',
      path: 'https://www.getec.vip/data/g22/22-annual-website-2-xinglinqiao.jpg',
    },
    {
      title: 'Haicang Bridge',
      text: "Haicang Bridge is a very important bridge that links Xiamen Island (where the city center is located) with the city's Haicang District located on the mainland.Asia's first and the world's second steel box girder continuous floating suspension bridge with three spans, it is a product of the top bridge engineering technology in China in the 20th century.",
      path: 'https://www.getec.vip/data/g22/22-annual-website-2-haicangqiao.jpg',
    },
    {
      title: 'Yanwu Bridge',
      text: 'This is a viewing platform with the sea facing, just near the Twin Towers, is a very hot door punching ground in Xiamen. The viewing platform is quite beautiful, there are flower beds and seats, and the sea view is not bad. The bridge Yanshen to the seaside, and the Shimao Building is on the side as a background, the angle is suitable to make a big movie. After watching the sunset, you can visit the Shimao Building and Shapowei.',
      path: 'https://www.getec.vip/data/g22/22-annual-website-2-yanwuqiao.jpg',
    },
    {
      title: 'Wuyuan Bridge',
      text: 'Wuyuan Bridge is located in the northeast direction of Huli District, Xiamen City, and is about 2.25 kilometers away from Tianyuan Bridge in the south. Half a mu Fangtang opened, skylight cloud shadows lingered. In the evening came to Xiamen Wuyuan Bridge, standing on the bridge to see the sea rising bright moon, watching the first Hua Lan, watching the dazzling building lights reflected on the sea, white clouds floating in the air. The Wuyuan Bridge, which is one of the components of the Wuyuan Bay, is a cross-sea passage in Xiamen City, Fujian Province, China.',
      path: 'https://www.getec.vip/data/g22/22-annual-website-2-wuyuanqiao.jpg',
    },
    {
      title: 'Xiamen Mountains-to-Sea Trail',
      text: 'The Xiamen Health Footpath starts at Dongdu Cruise Plaza and ends at Guanyinshan Beach. It is about 23 kilometers long. The trail was officially opened on New Year`s Day 2020. The trail is like a large pedestrian bridge.',
      path: 'https://www.getec.vip/data/g22/22-annual-website-2-jiankangbudao.jpg',
    },
    {
      title: 'Zhonggu Cableway',
      text: 'The Zhonggu Cableway is a new attraction in recent years, and the entrance is next to the Botanical Garden. The only downside is that you have to climb up high. Compared with other cableways, this cableway has both mountain and sea views.',
      path: 'https://www.getec.vip/data/g22/22-annual-website-2-zhonggusuodao.jpg',
    },
    {
      title: 'Bicycle Skyway',
      text: "China's incredible eight-kilometre 'bike lane in the sky' opens in Xiamen. It is China’s first suspended bicycle path and the world’s longest aerial bicycle lane. The aerial cycle way is a 4.8-metre wide four-lane carriageway stretching for 7.6 kilometres. It covers the city’s five major residential and three business centers. There are 11 entries on the path, which will connect with 11 bus stations and two subway stations.",
      path: 'https://www.getec.vip/data/g22/22-annual-website-2-zxckuaisudao.jpg',
    },
  ]

  swiperPartThree: any = [
    {
      title: 'Fujian cuisine',
      text: "Fujian cuisine or Fujianese cuisine, also known as Min cuisine, is one of the native Chinese cuisines derived from the native cooking style of China's Fujian Province. Fujian cuisine is known to be light but flavourful, soft, and tender, with particular emphasis on umami taste, known in Chinese cooking as xianwei, as well as retaining the original flavour of the main ingredients instead of masking them.",
      path: 'https://www.getec.vip/data/g22/22-annual-website-3-mincai.jpg',
    },
    {
      title: 'Shacha noodles',
      text: 'Shacha noodles , also known as sate or satay noodles, is a noodle dish popular in southern Fujian province. It is a kind of soup noodles made by cooking satay soup made from satay sauce and adding bean sprouts, pork liver, and other auxiliary materials.',
      path: 'https://www.getec.vip/data/g22/22-annual-website-3-shachamian.jpg',
    },
    {
      title: 'Oyster omelette',
      text: 'The dish consists of an omelette with a filling primarily composed of small oysters. Starch (typically sweet potato starch) is mixed into the egg batter, giving the resulting egg wrap a thicker consistency.Pork lard is often used to fry the resulting omelet. Depending on regional variations, a savory sauce may then be poured on top of the omelette for added taste.',
      path: 'https://www.getec.vip/data/g22/22-annual-website-3-hailijian.jpg',
    },
    {
      title: 'Sipunculid Worm Jelly',
      text: 'Sipunculid Worm Jelly is a dish consisting mainly gelatin extracted from boiled sea worms topped with spices and herbs such as cilantro, soy sauce, vinegar, and chili sauce. The literal translation of the name means “earth bamboo shoots, chilled.” These sea worms are commonly harvested in shallow, muddy beaches in the southwestern province of Fujian, China. Prices range from anywhere between five and ten kuai. Although the slimy, smooth texture and physical features of the worm might seem daunting to eat, this protein rich food is known for its ability to strengthen the immune system and ward off the common cold.',
      path: 'https://www.getec.vip/data/g22/22-annual-website-3-tusundong.jpg',
    },
    {
      title: 'Buddha Jumping Over the Wall',
      text: "A traditional famous dish of Fujian Province, is a kind of thick soup cooked with more than 30 kinds of ingredients including shark's fins, sea cucumber, chicken breast, duck meat, tendons of pork, mushroom.",
      path: 'https://www.getec.vip/data/g22/22-annual-website-3-fotiaoqiang.jpg',
    },
    {
      title: 'Ginger duck',
      text: 'Local ducks and aged gingers are the main ingredients. Instead of being cooked over fire, the spiced duck can also be braised in sand, which is good for maintaining temperature.',
      path: 'https://www.getec.vip/data/g22/22-annual-website-3-jiangmuya.jpg',
    },
  ]

  venueIntroduceOne: any = {
    images: [
      'https://www.getec.vip/data/g22/22-annual-700x850-1.jpg',
      'https://www.getec.vip/data/g22/22-annual-700x850-2.jpg',
      'https://www.getec.vip/data/g22/22-annual-700x850-3.jpg',
      'https://www.getec.vip/data/g22/22-annual-700x850-4.jpg',
      'https://www.getec.vip/data/g22/22-annual-700x850-5.jpg',
      'https://www.getec.vip/data/g22/22-annual-700x850-6.jpg',
    ]
  }

  mode: string = 'horizontal';

  created() {
    const winWidth = window.innerWidth;
    if (winWidth < 750) {
      this.mode = 'vertical'
    }
  }

  handleSelect(key: string) {
    this.activeIndex = key;
  }
}
